import axios from "axios";

const indicadorApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/indicador/graficos/`
})

async function servGetGraficoAlcanceTotalPeso(dataInicio, dataFim) {
    const response = await indicadorApi.get('mv/alcance-total-peso', {
        params: {dataInicio, dataFim}
    })   
    return response
}

async function servGetGraficoIndicadoresMensais(dataInicio, dataFim) {
    const response = await indicadorApi.get('mv/alcance-mensal-peso', {
        params: {dataInicio, dataFim}
    })
    return response
}
async function servGetGraficoDetalhamentoEstabelecimento(estabelecimentoId, dataInicio, dataFim) {
    const response = await indicadorApi.get('detalhamento-estabelecimento', {
        params: {estabelecimentoId, dataInicio, dataFim}
    })
    return response
}

async function servGetGraficoDetalhamentoMetrica(dataInicio, dataFim) {
    const response = await indicadorApi.get('mv/detalhamento-metrica', {
        params: {dataInicio, dataFim}
    })
    return response
}

// async function servGetGraficoDetalhamentoEstabelecimentoHeatMap(estabelecimentoId, dataInicio, dataFim) {
//     const response = await indicadorApi.get('detalhamento-estabelecimento-heat-map', {
//         params: {estabelecimentoId, dataInicio, dataFim}
//     })
//     return response
// }

async function servGetGraficoPercentualAlcanceEstabelecimentosHeatMap(dataInicio, dataFim) {
    const response = await indicadorApi.get('mv/percentual-alcance-unidades-heatmap', {
        params: { dataInicio, dataFim }
    })
    return response
}

async function servGetIndicadoresPorEstabelecimentoAndPeriodo(dataInicio, dataFim, estabelecimentoId) {
    const response = await indicadorApi.get('por-estabelecimento-e-mes', {
        params: { dataInicio, dataFim, estabelecimentoId }
    })
    return response
}

export {
    servGetGraficoAlcanceTotalPeso,
    servGetGraficoIndicadoresMensais,
    servGetGraficoDetalhamentoEstabelecimento,
    servGetGraficoDetalhamentoMetrica,
    // servGetGraficoDetalhamentoEstabelecimentoHeatMap,
    servGetGraficoPercentualAlcanceEstabelecimentosHeatMap,
    servGetIndicadoresPorEstabelecimentoAndPeriodo
}